export default __webpack_public_path__ + "static/media/g3.1b323c6e.png";